var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 1h-11c-.73 0-1.429.295-1.945.82A2.826 2.826 0 0 0 1 3.8v22.4c0 .743.29 1.455.805 1.98.516.525 1.216.82 1.945.82h16.5c.73 0 1.429-.295 1.945-.82A2.826 2.826 0 0 0 23 26.2V9.4L14.75 1Z",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.855 14.85c.606 0 1.116.205 1.53.613.414.408.62.909.62 1.503 0 .594-.206 1.095-.62 1.503-.414.408-.924.612-1.53.612H5.748v2.07H4.506v-6.3h2.349Zm0 3.07c.264 0 .483-.09.657-.27a.964.964 0 0 0 .26-.684.944.944 0 0 0-.26-.684.875.875 0 0 0-.657-.27H5.748v1.908h1.107ZM12.316 14.85c.864 0 1.584.304 2.16.91.582.606.873 1.353.873 2.24 0 .889-.29 1.636-.873 2.242-.576.606-1.296.909-2.16.909H9.814v-6.3h2.502Zm0 5.113c.546 0 .99-.18 1.332-.54.343-.366.514-.84.514-1.422s-.171-1.053-.514-1.413c-.341-.366-.785-.55-1.332-.55h-1.26v3.925h1.26ZM19.992 16.039h-2.52v1.494h2.448v1.188h-2.448v2.43H16.23v-6.3h3.762v1.188Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 1v8.4H23",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFile;